// eslint-disable-next-line no-restricted-imports
import { GenerateOtpResponseDto } from 'api/generated/graphql';
import { TwoFactorQrCodeGenerateData } from 'api/types/data';

export const parseData = (
  data: GenerateOtpResponseDto
): TwoFactorQrCodeGenerateData => ({
  qrUrl: data.qrUrl,
  secret: data.secret,
});
